import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useChannel } from '@/utils/hooks/useCentrifugo';

const ServerStatusContext = createContext(null);

const OFFLINE_GRACE = 10000;

export function ServerStatusProvider({ children }) {
    const [isOnline, setIsOnline] = useState(false);
    const [serverStatus, setServerStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const offlineTimer = useRef(null);

    const clearOfflineTimer = () => {
        if (offlineTimer.current === null) return;

        clearTimeout(offlineTimer.current);
        offlineTimer.current = null;
    };

    const goOffline = () => {
        clearOfflineTimer();
        setIsOnline(false);
        setIsLoading(false);
    };

    const scheduleOffline = () => {
        if (offlineTimer.current !== null) return;

        offlineTimer.current = setTimeout(goOffline, OFFLINE_GRACE);
    };

    useChannel('server:status', (payload) => {
        if (!payload || Object.keys(payload).length === 0) {
            goOffline();
            return;
        }

        clearOfflineTimer();

        setServerStatus(payload);
        setIsOnline(true);
        setIsLoading(false);
    }, { onError: scheduleOffline });

    useEffect(() => clearOfflineTimer, []);

    return (<ServerStatusContext.Provider value={{ isOnline, serverStatus, isLoading }}>
        {children}
    </ServerStatusContext.Provider>);
}

export function useServerStatus() {
    const ctx = useContext(ServerStatusContext);

    if (ctx === null) {
        throw new Error('useServerStatus precisa estar dentro de ServerStatusProvider');
    }

    return ctx;
}
